import { StrictMode } from "react";
import { createRoot } from "react-dom/client";
import { BrowserRouter } from "react-router-dom";
import { FournisseurSession } from "@/lib/session";
import { FournisseurToast } from "@/ui/Toast";
import { App } from "@/App";
import "@/styles/app.css";

/* Thème : clair par défaut, choix mémorisé par navigateur. */
try {
  const t = window.localStorage.getItem("omnix.desk.theme");
  if (t) document.documentElement.setAttribute("data-theme", t);
} catch {
  /* navigation privée ou stockage refusé : on reste en clair */
}

const racine = document.getElementById("root");
if (!racine) throw new Error("Élément #root introuvable");

createRoot(racine).render(
  <StrictMode>
    <BrowserRouter>
      <FournisseurSession>
        <FournisseurToast>
          <App />
        </FournisseurToast>
      </FournisseurSession>
    </BrowserRouter>
  </StrictMode>,
);
